import { GoEye } from "react-icons/go";
import { formatDate } from '../../../../../utils/dateFormat';
export { formatDate };

// ERE Status renderer with proper styling
export const renderEreStatus = (item) => {
  let statusText = '';
  let statusStyle = 'px-2 py-1 rounded-full text-base';

  if (item.emergency_leave_status) {
    statusText = item.emergency_leave_status;
    
    // Style based on status
    switch (item.emergency_leave_status) {
      case 'ON ERE':
        statusStyle += ' bg-blue-100 text-blue-800';
        break;
      case 'ERE ISSUED':
        statusStyle += ' bg-green-100 text-green-800';
        break;
      case 'ERE EXTENSION':
      case 'ON ERE EXTENSION_ISSUED':
        statusStyle += ' bg-purple-100 text-purple-800';
        break;
      case 'ERE EXTENSION-PAYMENT DONE':
        statusStyle += ' bg-green-100 text-green-800';
        break;
      case 'ON ERE-PAYMENT DONE':
        statusStyle += ' bg-green-100 text-green-800';
        break;
      case 'ON ERE-PENDING PAYMENT':
        statusStyle += ' bg-yellow-100 text-yellow-800';
        break;
      default:
        statusStyle += ' bg-gray-100 text-gray-800';
    }
  } else {
    // Fallback logic for sla_fees
    if (item.sla_fees) {
      statusText = item.sla_fees === "BORNE" ? "PAYMENT DONE" : item.sla_fees;
      statusStyle += item.sla_fees === "BORNE" ? ' bg-green-100 text-green-800' : ' bg-yellow-100 text-yellow-800';
    } else {
      statusText = "ERE-EMERGENCY LEAVE";
      statusStyle += ' bg-gray-100 text-gray-800';
    }
  }

  return (
    <span className={statusStyle}>
      {statusText}
    </span>
  );
};

// Action button renderer
export const renderActionButton = (item, handleClick, handleEreExtendClick) => {
  const isExtensionStatus = [
    "ON ERE EXTENSION_ISSUED",
    "ERE EXTENSION-PAYMENT DONE", 
    "ERE EXTENSION"
  ].includes(item.emergency_leave_status);

  const isDisabled = item.emergency_leave_status === "ON ERE-PENDING PAYMENT" || 
                     item.sla_fees === "TO BE PAID";

  const handleButtonClick = () => {
    if (isExtensionStatus) {
      handleEreExtendClick(item);
    } else {
      handleClick(item);
    }
  };

  return (
    <button
      onClick={handleButtonClick}
      disabled={isDisabled}
      className={`ml-2 ${isDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
      style={{
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isDisabled ? 0.5 : 1
      }}
    >
      <GoEye fontSize={22} />
    </button>
  );
};

// Memoized columns configuration
export const ERE_COLUMNS = [
  { key: 'serial', title: 'S.NO.', searchable: false },
  { key: 'point_of_hire', title: 'POINT OF HIRE', searchable: true },
  { key: 'candidate_id', title: 'EMPLOYEE ID', searchable: true },
  { key: 'name', title: 'EMPLOYEE NAME', searchable: true },
  { key: 'nationality', title: 'NATIONALITY', searchable: true },
  { key: 'actual_profession', title: 'ACTUAL PROFESSION', searchable: true },
  { key: 'visa_profession', title: 'VISA PROFESSION', searchable: true },
  { key: 'total_salary', title: 'TOTAL SALARY', searchable: false },
  { key: 'client', title: 'CLIENT', searchable: true },
  { key: 'visa_provider', title: 'VISA PROVIDER', searchable: true },
  { key: 'iqama_number', title: 'IQAMA NUMBER', searchable: true },
  { key: 'iqama_expiry_date_g', title: 'IQAMA EXPIRY DATE', searchable: false },
  { key: 'arrival_date', title: 'ARRIVAL DATE', searchable: false },
  { key: 'mobilization_date', title: 'MOBILIZATION DATE', searchable: false },
  { key: 'demobilization_date', title: 'DEMOBILIZATION DATE', searchable: false },
  { key: 'demobilization_comments', title: 'DEMOBILIZATION COMMENTS', searchable: false },
  { key: 'idle_aging', title: 'IDLE', searchable: false },
  { key: 'aging', title: 'AGING', searchable: false },
  { key: 'entry_before_date', title: 'ENTRY BEFORE DATE', searchable: false },
  { key: 'emergency_leave_status', title: 'STATUS', searchable: true },
  { key: 'action', title: 'ACTION', searchable: false }
];

// Constants for better maintainability
export const ERE_CONFIG = {
  API_ENDPOINT: "/demobilization/idleCandidates/ERE-EMERGENCY LEAVE",
  DOWNLOAD_ENDPOINT: "/demobilization/idleCandidates/download/ERE-EMERGENCY LEAVE", 
  DOWNLOAD_FILENAME: "ERE_Emergency_Leave_summary",
  SEARCH_PLACEHOLDER: "Search ERE employees...",
  NO_DATA_MESSAGE: "No ERE employees found",
  DEBOUNCE_MS: 300,
  DEFAULT_PAGE_SIZE: 50,
  PAGE_SIZE_OPTIONS: [50, 100, 500, 1000],
  UPDATE_ERE_ENDPOINT: "/ere/updateEreByDate"
};

// Memoized searchable fields derived from columns
export const ERE_SEARCHABLE_FIELDS = ERE_COLUMNS
  .filter(col => col.searchable)
  .map(col => col.key);

// ERE Status constants for validation and logic
export const ERE_STATUS_TYPES = {
  ON_ERE: "ON ERE",
  ERE_ISSUED: "ERE ISSUED", 
  ERE_EXTENSION: "ERE EXTENSION",
  ON_ERE_EXTENSION_ISSUED: "ON ERE EXTENSION_ISSUED",
  ERE_EXTENSION_PAYMENT_DONE: "ERE EXTENSION-PAYMENT DONE",
  ON_ERE_PAYMENT_DONE: "ON ERE-PAYMENT DONE",
  ON_ERE_PENDING_PAYMENT: "ON ERE-PENDING PAYMENT"
};

// Extension status types for conditional logic
export const ERE_EXTENSION_STATUSES = [
  ERE_STATUS_TYPES.ON_ERE_EXTENSION_ISSUED,
  ERE_STATUS_TYPES.ERE_EXTENSION_PAYMENT_DONE,
  ERE_STATUS_TYPES.ERE_EXTENSION
];

// Search key fields for the old search functionality (to maintain compatibility)
export const ERE_SEARCH_KEYS = [
  "employee_id",
  "visa_reference_number", 
  "border_number"
];